export const userSessionCookie = 'playment.user'
export const fbLoginCookie = 'playment.fbLogin'

const UAT = 'uat'
const TESTING = 'testing'
const PRODUCTION = 'production'
const DEVELOPMENT = 'development'

export default {
    UAT,
    PRODUCTION,
    TESTING,
    DEVELOPMENT,
}
